import { useEffect, useState } from 'react';

import useClientState from '@/state/useClientState';
import { Line } from '@visx/shape';

import useMwdTimescale from '../../state/selectors/useMwdTimescale';
import { getCoordinates } from '../../utils/timescale';

const CurrentTimeLine = ({ mini = false, chartHeight }: { mini?: boolean; chartHeight?: number }) => {
  const mwdHeight = useClientState((state) => (mini ? state.miniMwd.height : state.mwd.height));
  const mwdWidth = useClientState((state) => (mini ? state.miniMwd.width : state.mwd.width));
  const zoom = useClientState((state) => (mini ? state.miniMwd.zoom : state.mwd.zoom));
  const { scale, start, end } = useMwdTimescale(mini ? 'miniMwd' : 'mwd');

  const [timeOffsetPx, setTimeOffsetPx] = useState<number>(getCoordinates({ start, end, scale }, new Date()).x);
  useEffect(() => {
    const timeInterval = setInterval(() => {
      const time = getCoordinates({ start, end, scale }, new Date());
      setTimeOffsetPx(time.x);
    }, 1_000);
    return () => {
      clearInterval(timeInterval);
    };
  }, [mwdWidth, start, zoom]);

  return (
    <Line
      id='now'
      data-testid='current-time-line'
      stroke='var(--tractie-color-content-default)'
      strokeWidth={3}
      shapeRendering='crispEdges'
      from={{ x: timeOffsetPx, y: 0 }}
      to={{ x: timeOffsetPx, y: (chartHeight ?? mwdHeight) + 8 }}
    />
  );
};
export default CurrentTimeLine;
